import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Box, Card, Checkbox, Table, TableBody, TableCell, TableHead, TablePagination, TableRow } from '@mui/material';
import EntityConfirmDelete from '../subcomponents/EntityConfirmDelete';
import { DeleteIcon, StudentIcon, EditIcon, CalendarIcon } from '../../Icons'
import CUModal from '../modals/CUModal';
import UsersByGroupList from '../UserByGroupList/UserByGroupList';
import { UPDATE_GROUP, CREATE_GROUP } from "../../../graphql/admin-requests";
import CUSimpleItem from "../CreateUpdateComponents/SimpleItem";
import CustomIconButton from "../subcomponents/CustomIconButton";
import { useRowSelection } from "../../../hooks/useRowSelection";


const GroupListResults = ({
    groups,
    totalCount,
    setLimit,
    limit,
    setOffset,
    offset,
    handleDeleteGroup,
    loadData,
    viewGroupCalendar,
    ...rest }) => {

    const { selectedIds: selectedGroupIds, handleSelectAll, handleSelectOne } = useRowSelection(groups);
    const [page, setPage] = useState(0);
    const [openDialog, setOpenDialog] = useState(false);
    const [toDelete, setToDelete] = useState({});
    const [groupToUpdate, setGroupToUpdate] = useState({});
    const [openUpdateModal, setOpenUpdateModal] = useState(false);

    const [openUserListModal, setOpenUserListModal] = useState(false);
    const [groupUid, setGroupUid] = useState("");

    const showUserListModal = (uid) => {
        setGroupUid(uid);
        setOpenUserListModal(true);
    }

    const handleLimitChange = async (event) => {
        await setLimit(event.target.value);
    };

    const openConfirmDelete = (group) => {
        setToDelete(group);
        setOpenDialog(true);
    }

    const closeDialog = () => setOpenDialog(false);

    const handlePageChange = async (event, newPage) => {
        await setOffset(newPage * limit);
        await setPage(newPage);
    };

    return (
        <>
            <CUModal open={openUserListModal} groupUid={groupUid} handleClose={() => setOpenUserListModal(false)} component={UsersByGroupList} />
            <CUModal
                open={openUpdateModal}
                toUpdate={groupToUpdate}
                handleClose={() => { setOpenUpdateModal(false); loadData() }}
                component={CUSimpleItem}
                itemName="groupe"
                createRequest={CREATE_GROUP}
                updateRequest={UPDATE_GROUP} />
            <EntityConfirmDelete
                open={openDialog}
                item={toDelete}
                itemLabel="un groupe"
                onClose={closeDialog}
                onConfirm={() => handleDeleteGroup(toDelete.uid)}
            />
            <Card {...rest}>
                <Box sx={{ overflowX: 'auto' }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell padding="checkbox">
                                    <Checkbox
                                        checked={selectedGroupIds.length === groups.length}
                                        color="primary"
                                        indeterminate={
                                            selectedGroupIds.length > 0
                                            && selectedGroupIds.length < groups.length
                                        }
                                        onChange={handleSelectAll}
                                    />
                                </TableCell>
                                <TableCell size="small">Nom</TableCell>
                                <TableCell size="small">Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {[...groups]
                                .sort((a, b) => a.name.localeCompare(b.name, 'fr', { numeric: true, sensitivity: 'base' }))
                                .slice(0, limit)
                                .map((group) => (
                                <TableRow hover key={group.uid} selected={selectedGroupIds.indexOf(group.uid) !== -1}>
                                    <TableCell padding="checkbox">
                                        <Checkbox
                                            checked={selectedGroupIds.indexOf(group.uid) !== -1}
                                            onChange={(event) => handleSelectOne(event, group.uid)}
                                            value="true"
                                        />
                                    </TableCell>
                                    <TableCell size="small">{group.name}</TableCell>
                                    <TableCell size="small">
                                        <CustomIconButton
                                            title="Elèves"
                                            button={<Button
                                                onClick={() => showUserListModal(group.uid)}
                                                size="small"
                                                variant="outlined"
                                                color="default"
                                                endIcon={<StudentIcon />}
                                            >{group.userGroupsByGroupUid.totalCount}</Button>} />
                                        <CustomIconButton
                                            title="Voir emplois du temps"
                                            link={`/superadmins/calendars/group/${group.uid}`}
                                            icon={<CalendarIcon />} />
                                        <CustomIconButton
                                            onClick={() => {
                                                setGroupToUpdate(group); setOpenUpdateModal(true);
                                            }}
                                            title="Modifier"
                                            icon={<EditIcon />} />
                                        <CustomIconButton
                                            onClick={() => openConfirmDelete(group)}
                                            title="Supprimer"
                                            icon={<DeleteIcon />} />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Box>
                <TablePagination
                    component="div"
                    count={totalCount}
                    onPageChange={handlePageChange}
                    onRowsPerPageChange={handleLimitChange}
                    page={page}
                    rowsPerPage={limit}
                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                />
            </Card >
        </ >
    );
};

GroupListResults.propTypes = {
    groups: PropTypes.array.isRequired
};

export default GroupListResults;
